import React from 'react'
import { Box, Paper } from '@mui/material'
import {
  VerificationLoader,
  LogoHeader,
  LegalOverlay,
  PatientInformationForm,
  WalletCardDownload,
} from './components'
import './PatientWalletCard.scss'
import { usePatientWalletCard } from './PatientWalletCard.logic'

/**
 * Patient Wallet Card Page
 *
 * IMPORTANT: This is a public route accessible without authentication.
 * Do not add any components or services that require authentication.
 */
const PatientWalletCard: React.FC = () => {
  const {
    verifyLoading,
    verifyError,
    verifyData,
    showDownloadView,
    legalOverlay,
    createSurgeryPassLoading,
    createSurgeryPassError,
    existingSurgeryPass,
    inviteToken,
    handleOpenLegalOverlay,
    handleCloseLegalOverlay,
    handleSubmit,
  } = usePatientWalletCard()

  if (verifyLoading || !verifyData) {
    return <VerificationLoader isLoading={true} />
  }

  if (
    verifyError ||
    !verifyData?.success ||
    !verifyData?.data?.surgeryId ||
    !verifyData?.data?.patientId
  ) {
    return <VerificationLoader isLoading={false} error={true} />
  }

  return (
    <Box className="wallet-card-container" p={3}>
      <Paper elevation={3} className="wallet-card-paper">
        <LogoHeader />

        {!showDownloadView ? (
          <PatientInformationForm
            onSubmit={handleSubmit}
            loading={createSurgeryPassLoading}
            error={createSurgeryPassError}
            onLegalContentOpen={handleOpenLegalOverlay}
            invitationData={
              verifyData?.data
                ? {
                    fullName: verifyData.data.fullName,
                    dateOfBirth: verifyData.data.dateOfBirth,
                  }
                : undefined
            }
          />
        ) : (
          <WalletCardDownload
            patientId={verifyData.data!.patientId}
            surgeryId={verifyData.data!.surgeryId}
            webToken={existingSurgeryPass?.data?.webToken}
            inviteToken={inviteToken}
          />
        )}
      </Paper>

      <LegalOverlay
        open={legalOverlay.open}
        content={legalOverlay.content}
        onClose={handleCloseLegalOverlay}
      />
    </Box>
  )
}

export default PatientWalletCard
